export default (pgTimestamp?: string): string => {
    if (pgTimestamp) {
        const date = new Date(pgTimestamp.replace(' ', 'T'));
        return `${date.getDate()} ${date.toLocaleDateString('default', {month: 'long'})} ${date.getFullYear()}`
    }
    return '';
}
